import { gql } from '@apollo/client';

export const JOB_SUMMARY_FIELDS = gql`
  fragment JobSummaryFields on JobSummary {
    id
    partyId
    merchantChannelId
    type
    state
    scheduledToStartAt
    createdAt
    startedAt
    finishedAt
  }
`;

export const JOB_FIELDS = gql`
  fragment JobFields on Job {
    id
    partyId
    merchantChannelId
    type
    state
    input
    output
    scheduledToStartAt
    createdAt
    startedAt
    finishedAt
  }
`;
